import {connect} from 'react-redux';
import Rules from './Rules';

const mapStateToProps = ({college}) => ({college});

export default connect(mapStateToProps)(Rules);
